'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_RegisterDirectivePage(url, selector) {
  this.D3 = null;
  this.D2 = null;
  this.D3 = url;
  this.D2 = selector;
}
export { $c_Lpresto_RegisterDirectivePage as $c_Lpresto_RegisterDirectivePage };
$p = $c_Lpresto_RegisterDirectivePage.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_RegisterDirectivePage;
/** @constructor */
function $h_Lpresto_RegisterDirectivePage() {
}
export { $h_Lpresto_RegisterDirectivePage as $h_Lpresto_RegisterDirectivePage };
$h_Lpresto_RegisterDirectivePage.prototype = $p;
$p.dw = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$();
});
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lpresto_RegisterDirectivePage) && ((this.D3 === x$0.D3) && (this.D2 === x$0.D2))));
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 2;
});
$p.s = (function() {
  return "RegisterDirectivePage";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.D3;
  }
  if ((n === 1)) {
    return this.D2;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lpresto_RegisterDirectivePage(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.iM)));
}
export { $isArrayOf_Lpresto_RegisterDirectivePage as $isArrayOf_Lpresto_RegisterDirectivePage };
var $d_Lpresto_RegisterDirectivePage = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_RegisterDirectivePage, "presto.RegisterDirectivePage", ({
  iM: 1,
  a2: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_RegisterDirectivePage as $d_Lpresto_RegisterDirectivePage };
//# sourceMappingURL=presto.-Register-Directive-Page.js.map
